import { render } from "./IconResize.vue?vue&type=template&id=886602d2"
import script from "./IconResize.vue?vue&type=script&lang=js"
export * from "./IconResize.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__